<template>
  <div
    v-if="(!isLoadingReport && mostDifficultQuestions && mostDifficultQuestions.length > 0)
      || isLoadingReport"
    class="aha-report-difficult-questions"
  >
    <div class="flex flex-row items-center p-4">
      <div
        class="flex items-center justify-center w-6 h-6 mr-1 rounded-full"
        :class="{ 'bg-secondary-15': isLoadingReport, 'bg-red-10': !isLoadingReport }"
      >
        <aha-icon
          :class="{ 'text-secondary-40': isLoadingReport, 'text-red-50': !isLoadingReport }"
          name="question"
          width="16"
          height="16"
          viewBox="0 0 24 24"
        />
      </div>
      <p
        class="font-bold mr-1.5"
        :class="{ 'text-secondary-40': isLoadingReport, 'text-secondary-100': !isLoadingReport }"
      >
        {{ $i18nPresenter.t('Difficult questions:') }}
        <span
          class="text-red-50"
          v-if="mostDifficultQuestions && mostDifficultQuestions.length > 0"
        >
          {{ mostDifficultQuestions.length }}
        </span>
        <aha-skeleton-loader
          class="relative -top-0.25"
          width="50px"
          v-else
        />
      </p>
      <i
        v-show="!isLoadingReport"
        class="fas fa-question-circle text-secondary-40 cursor-pointer relative -top-0.25"
        v-tooltip="$i18nPresenter.t('The number of questions that had less than a 40% correct rate.')"
      />
    </div>
    <div class="mx-3 mb-4 border-b border-base-30"></div>
    <div class="body">
      <div v-if="!isLoadingReport && mostDifficultQuestions && mostDifficultQuestions.length > 0">
        <slide-card
          v-for="slide in mostDifficultQuestions"
          :key="slide.id"
          :slide="slide"
          class="mb-4"
        >
          <div class="flex flex-row items-center cursor-pointer">
            <v-popover
              trigger="hover"
              placement="top"
              popoverInnerClass=""
            >
              <aha-progress-circle
                class="mr-1 -mt-0.5"
                inner-circle-color="#FF4954"
                progress-bar-color="#33C173"
                :percent="slide.correctRate * 100"
                :radius="7"
                :ring-width="3"
                box-shadow="none"
                inner-box-shadow="none"
              />
              <span class="text-sm text-base-80">
                {{ (slide.correctRate * 100).toFixed(1) + '%' }}
              </span>
              <template slot="popover">
                <DifficultTooltip :slide="slide" />
              </template>
            </v-popover>
          </div>
        </slide-card>
      </div>
      <div v-else>
        <slide-card
          class="mb-4"
          is-loading
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SlideCard from '@/components-v2/presentation-report/SlideCard.vue'
import DifficultTooltip from '@/components-v2/presentation-report/DifficultTooltip.vue'

export default {
  components: {
    SlideCard,
    DifficultTooltip,
  },
  data() {
    return {
      msg: '',
    }
  },
  computed: {
    ...mapGetters('presentationReport', ['mostDifficultQuestions', 'isLoadingReport']),
  },
}
</script>

<style lang="scss">
// remove scoped attribute on <style> and use unique class to target popover's trigger
.aha-report-difficult-questions {
  @apply pb-2 bg-base-0 rounded-lg;
  box-shadow: 0px 2px 6px rgba(211, 215, 225, 0.65);

  .trigger {
    @apply flex-row items-center;
    display: flex !important; // override popover's inline style
  }
}

</style>
